import script from "./EventsGuestMembers.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventsGuestMembers.vue?vue&type=script&setup=true&lang=ts"

import "./EventsGuestMembers.vue?vue&type=style&index=0&id=4d9034a7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d9034a7"]])

export default __exports__